export default "__VITE_ASSET__BHPIMjsj__"